
/* injects from baggage-loader */

'use strict';

export default function (app) {
  app
  .factory('Session', SessionFactory);

  function SessionFactory($state) {
    'ngInject';

    let self = {
      enabled: true
    };

    self.$state = $state;

    self.create = function(){
      let updates = {};
      
      updates = {
        stages:[
        {
          name: "Sabedoria",
          route: "sabedoria",
          levels: 1,
          completed: false,
          times: [0,0,0]
        },
        {
          name: "Imaginação",
          route: "imaginacao",
          levels: 1,
          completed: false,
          times: [0,0,0]
        },
        {
          name: "Pensamento",
          route: "pensamento",
          levels: 1,
          completed: false,
          times: [0,0,0]
        },
        {
          name: "Viagem para Tetrix",
          route: "tetraedro",
          levels: 1,
          completed: false,
          times: [0, 0, 0]
        }
        ]
      };

      // set shared currentUser
      // $rootScope.$currentUser = user

      return sessionStorage.$session = JSON.stringify(updates);
    }

    self.save = function(updates, all){
      if(all){
        sessionStorage.$session = JSON.stringify(updates);
      } else{
        sessionStorage.$session = JSON.stringify({ stages: updates.stages });
      }
      return 
    }

    self.countLevel = function(timer, stage, forceComplete){
      let updates = self.get();
      let level = updates.stages[stage].levels;
      
      if (forceComplete){
        updates.stages[stage].levels = 4
        updates.stages[stage].completed = true
      } else{
        updates.stages[stage].times[level-1] = timer;
  
        if(level < 3){
          updates.stages[stage].levels++;
        } else if(!updates.stages[stage].completed) {
          updates.stages[stage].levels++;
          updates.stages[stage].completed = true;
        } 
      }

      
      sessionStorage.$session = JSON.stringify(updates);

    }

    self.getKeys = function(){
      let updates = self.get();
      let keys = [];
      for(let i = 0; i < updates.stages.length; i++){
        keys.push(updates.stages[i].completed)
      }
      return keys;
    }

    self.get = function(){
      try {
        return JSON.parse(sessionStorage.$session);        
      } catch (error) {
        return undefined;
      }
    }

    self.destroy = function(){
      delete sessionStorage.$session;
      return $state.go('login');
    }

    return self;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/session.factory.js